import { InvalidateOrganisationCacheRequest, InvalidateOrganisationCacheResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';

export interface InvalidateOrganisationCachePayload {
  organisationDisplayName: string;
}

export interface InvalidateOrganisationCacheResult {
  displayName: string;
  liftClientNames: string[];
  invalidatedKeyCount: number;
  warnings: string[];
}

export default class InvalidateOrganisationCache extends BaseAdapter<InvalidateOrganisationCacheResponse> {
  rawResponse: InvalidateOrganisationCacheResponse;

  modifiedRequest: InvalidateOrganisationCacheRequest;

  async adaptResponse(
    payload: InvalidateOrganisationCachePayload,
  ): Promise<InvalidateOrganisationCacheResult> {
    await this.fetchApiResponse(
      '/api/admin/organisation/invalidate-cache',
      HTTPMethod.Post,
      this.adaptRequest(payload)
    );
    const {
      display_name, lift_client_names, invalidated_key_count, warnings
    } = this.rawResponse;

    return {
      displayName: display_name,
      liftClientNames: lift_client_names,
      invalidatedKeyCount: invalidated_key_count,
      warnings,
    };
  }

  adaptRequest(payload: InvalidateOrganisationCachePayload): InvalidateOrganisationCacheRequest {
    this.modifiedRequest = {
      organisation_display_name: payload.organisationDisplayName,
    };
    return this.modifiedRequest;
  }
}
